<template>
  <div class="pdf-viewer">
    <div class="d-flex flex-wrap align-items-center mb-3 pdf-toolbar">
      <p-button type="success" @click="goBack" class="mr-2 mb-2">
        <i class="bi bi-arrow-left"></i> Zurück
      </p-button>
      <a
        v-if="pdfUrl && !useFallback"
        :href="pdfUrl"
        target="_blank"
        rel="noopener"
        class="btn btn-default mr-2 mb-2"
      >
        <i class="bi bi-box-arrow-up-right"></i> In neuem Tab öffnen
      </a>
      <a
        v-if="pdfUrl && !useFallback"
        :href="pdfUrl"
        :download="downloadFilename"
        target="_blank"
        rel="noopener"
        class="btn btn-default mb-2"
      >
        <i class="bi bi-download"></i> Herunterladen
      </a>
    </div>

    <!-- iOS / mobile fallback: iframes do not render PDFs reliably on iOS WebKit -->
    <div v-if="useFallback" class="pdf-fallback text-center">
      <i class="bi bi-file-earmark-pdf pdf-fallback-icon"></i>
      <h5 class="mt-3">PDF-Vorschau auf diesem Gerät nicht verfügbar</h5>
      <p class="text-muted">
        Auf iPhone/iPad können PDFs in der App leider nicht direkt angezeigt werden.
        Öffne das Dokument bitte in einem neuen Tab oder lade es herunter.
      </p>
      <div class="mt-3">
        <a
          v-if="pdfUrl"
          :href="pdfUrl"
          target="_blank"
          rel="noopener"
          class="btn btn-success mr-2"
        >
          <i class="bi bi-box-arrow-up-right"></i> PDF öffnen
        </a>
        <a
          v-if="pdfUrl"
          :href="pdfUrl"
          :download="downloadFilename"
          target="_blank"
          rel="noopener"
          class="btn btn-default"
        >
          <i class="bi bi-download"></i> Herunterladen
        </a>
      </div>
    </div>

    <!-- Desktop / Android: inline iframe -->
    <div v-else-if="pdfUrl" class="pdf-iframe-wrap">
      <iframe :src="pdfUrl" class="pdf-iframe" title="PDF"></iframe>
    </div>
  </div>
</template>
<script>

  import { storage } from '../../../../firebaseDb'
  import { ref, getDownloadURL } from "firebase/storage";
  import store from "../../../../store";
  import router from "../../../../main";

  export default {
    data () {
      return {
        filepath: null,
        pdfUrl: null,
        isIOS: false,
      }
    },
    computed: {
      useFallback() {
        // iOS WebKit (Safari, Chrome iOS, ...) does not render PDFs inside iframes reliably.
        return this.isIOS;
      },
      downloadFilename() {
        const f = this.$route.params.file;
        if (!f) return 'dokument.pdf';
        return f.toString().endsWith('.pdf') ? f : f + '.pdf';
      },
    },
    created () {
      this.isIOS = this.detectIOS();
      var requestedFile = this.$route.params.file
      var requestedLink = this.$route.params.link
      if(requestedLink) {
        this.pdfUrl = requestedLink
      } else {
        this.loadFile(requestedFile)
        store.watch(
          (state) => state.userlocation,
          () => {
            this.loadFile(requestedFile);
          }
        );
      }
    },
    methods: {
      detectIOS() {
        if (typeof navigator === 'undefined') return false;
        const ua = navigator.userAgent || '';
        // iPhone / iPad / iPod, plus iPadOS 13+ which reports as Mac with touch.
        const iOS = /iPad|iPhone|iPod/.test(ua);
        const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        return iOS || iPadOS;
      },
      loadFile(requestedFile) {
        
        if(requestedFile === 'unfallprotokoll') {
          if(store.getters.userlocation == "DA") {
            this.filepath = "/PDF/Unfallprotokoll-da.pdf"
          }
          if(store.getters.userlocation == "NB") {
            this.filepath = "/PDF/Unfallprotokoll-nb.pdf"
          }
          if(store.getters.userlocation == "FRA") {
            this.filepath = "/PDF/Unfallprotokoll-fra.pdf"
          }
        }
        else if(requestedFile === 'kinderprogramme') {
          if(store.getters.userlocation == "DA") {
            this.filepath = "/PDF/Kinderprogramme-Liste-da.pdf"
          }
          if(store.getters.userlocation == "NB") {
            this.filepath = "/PDF/Kinderprogramme-Liste-nb.pdf"
          }
          if(store.getters.userlocation == "FRA") {
            this.filepath = "/PDF/Kinderprogramme-Liste-fra.pdf"
          }
        } else {
          this.filepath = "/PDF/" + requestedFile + ".pdf"
        }
        

        getDownloadURL(ref(storage, this.filepath)).then((url) => {
          this.pdfUrl = url
        })
      },
      goBack() {
        router.go(-1)
      }
    },
    watch: {
      '$route.params.file': function (file) {
        this.loadFile(file)
      }
    }
  }

</script>
<style scoped>
.pdf-toolbar {
  gap: 0.25rem;
}
.pdf-iframe-wrap {
  width: 100%;
}
.pdf-iframe {
  width: 100%;
  height: calc(100vh - 160px);
  min-height: 500px;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
  background: #fff;
}
.pdf-fallback {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 2rem 1rem;
}
.pdf-fallback-icon {
  font-size: 3rem;
  color: #dc3545;
}
</style>
